import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { useContent } from "@/hooks/useData";

export const WhoWeWork = () => {
  const { content } = useContent();
  const c = content.who;
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28" data-testid="who-we-work-section">
      <SectionHeading eyebrow={c.eyebrow} title={c.title} accent={c.accent} />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#ECEAE4] mt-14 border border-[#ECEAE4]">
        {c.items.map((w, i) => (
          <Reveal key={i} delay={i * 0.08} className="bg-[#FFFFFF] p-8 sm:p-10">
            <span className="font-display text-5xl text-[#D8D3C9]">0{i + 1}</span>
            <h3 className="font-display text-2xl font-medium text-[#2C2A29] mt-4">{w.title}</h3>
            <p className="text-[#5E5A54] font-light leading-relaxed mt-3">{w.description}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
